import React, { Component, Fragment } from 'react';
import AnchoredPortal from './AnchoredPortal';
import { Button } from 'components';
import Icon from 'assets/icons';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './PopupButton.module.scss';

class PopupButton extends Component {
  static propTypes = {
    anchored: PropTypes.bool,
    arrow: PropTypes.bool,
    buttonActiveClass: PropTypes.string,
    buttonClassName: PropTypes.string,
    buttonProps: PropTypes.object,
    children: PropTypes.node,
    className: PropTypes.string,
    closeOnClick: PropTypes.bool,
    Component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    disabled: PropTypes.bool,
    expandPopup: PropTypes.bool,
    hideLabel: PropTypes.bool,
    hoverToOpen: PropTypes.bool,
    id: PropTypes.string.isRequired,
    label: PropTypes.node,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    openLabel: PropTypes.node,
    popupClassName: PropTypes.string,
    // tooltip: PropTypes.node,
    // tooltipPos: PropTypes.string,
    tooltipText: PropTypes.string,
    type: PropTypes.string,
  };

  state = {
    open: false,
  };

  handleToggleClick = () => {
    const { onClose, onOpen } = this.props;
    const { open } = this.state;

    if (!open) {
      window.addEventListener('click', (event) => this.handleOutsideClick(event), true);

      if (onOpen) {
        onOpen();
      }
    } else {
      window.removeEventListener('click', (event) => this.handleOutsideClick(event), true);

      if (onClose) {
        onClose();
      }
    }

    this.setState({ open: !open });
  };

  handleClosePopup = () => {
    if (this.state.open && this.props.onClose) {
      this.props.onClose();
    }

    window.removeEventListener('click', (event) => this.handleOutsideClick(event), true);

    this.setState({ open: false });
  };

  handleHover = () => {
    const { onMouseEnter } = this.props;
    if (typeof onMouseEnter !== 'undefined') {
      onMouseEnter(false);
    }
  };

  handleOutsideClick = (event) => {
    const { id } = this.props;
    const elementButton = document.getElementById(`popup-${id}-button`);
    const elementContent = document.getElementById(`popup-${id}-content`);

    if (
      elementContent &&
      !elementContent.contains(event.target) &&
      elementButton &&
      !elementButton.contains(event.target) &&
      this.state.open &&
      !event.target.closest(`#popup-${id}-button`)
    ) {
      // Clicked outside the box
      this.handleClosePopup();
    }
  };

  render() {
    const {
      alwaysRender = false,
      anchored = false,
      arrow = false,
      buttonActiveClass,
      buttonClassName,
      buttonProps = {},
      children,
      className,
      closeOnClick = false,
      Component = Button,
      disabled,
      expandPopup = false,
      hideLabel = false,
      hoverToOpen = false,
      id,
      label,
      openLabel,
      popupClassName,
      // tooltip,
      // tooltipPos,
      tooltipText,
      type,
    } = this.props;

    const anchorClasses = classnames(className, {
      [styles.anchor]: true,
      [styles.arrowPadding]: arrow,
      [styles.hoverToOpen]: hoverToOpen,
      [styles[`type-${type}__wrapper`]]: type,
    });

    const arrowClasses = classnames({
      [styles.arrow]: true,
      [styles.popupOpen]: this.state.open,
    });

    const popupStyle = {};
    if (!hoverToOpen) {
      popupStyle.display = this.state.open ? 'block' : 'none';
    }

    const popupClasses = classnames(popupClassName, {
      [styles.popup]: true,
      [styles.expandPopup]: expandPopup,
    });

    const activeClasses = classnames('hideTooltip', buttonActiveClass);

    const content =
      this.state.open || alwaysRender ? (
        <div
          className={popupClasses}
          onClick={closeOnClick ? this.handleClosePopup : undefined}
          style={popupStyle}
          id={`popup-${id}-content`}
        >
          {children}
        </div>
      ) : null;

    return (
      <div className={anchorClasses} id={`popup-${id}-button`} onMouseEnter={this.handleHover}>
        <Component
          {...buttonProps}
          className={classnames(
            styles.clickable,
            buttonClassName,
            this.state.open ? activeClasses : '',
            {
              [styles[`type-${type}`]]: type,
            }
          )}
          data-tooltip={tooltipText}
          onClick={!disabled && !hoverToOpen ? this.handleToggleClick : undefined}
        >
          <div className={styles.labelAnchor}>
            {!hideLabel && (
              <div className={styles.label}>{(this.state.open && openLabel) || label}</div>
            )}

            {arrow && (
              <div className={styles.arrowContainer}>
                <Icon.TriangleDown className={arrowClasses} />
              </div>
            )}
          </div>
        </Component>

        <Fragment>
          {/* {tooltip && (
            <div style={popupStyle}>
              <Tooltip className={styles.popup} pos={tooltipPos}>
                {tooltip}
              </Tooltip>
            </div>
          )} */}
          {anchored ? <AnchoredPortal>{content}</AnchoredPortal> : content}
        </Fragment>
      </div>
    );
  }
}

export default PopupButton;
